import { useEffect } from "react";
import { useForm } from "react-hook-form";

import { yupResolver } from "@hookform/resolvers/yup";
import { yup } from "utils";

const yupSchema = yup.object({
  name: yup
    .string()
    .trim()
    .when("$showActions", (showActions, schema) => {
      return showActions ? schema.required() : schema;
    }),
});

export function useFormName(onSubmit, onChange, { initialValue, showActions }) {
  const formProps = useForm({
    mode: "onChange",
    defaultValues: { name: initialValue },
    resolver: yupResolver(yupSchema),
    context: { showActions },
  });

  const {
    handleSubmit,
    formState: { isDirty, isValid },
    watch,
  } = formProps;

  const watchName = watch("name");

  useEffect(() => {
    onChange(watchName);
  }, [watchName, onChange]);

  return {
    formProps: formProps,
    isReady: isDirty && isValid,
    handleSubmit: handleSubmit(async ({ name }) => {
      await onSubmit(name);
    }),
  };
}

export default useFormName;
